import React from 'react';

import { SVGComponentProps } from './svg.types';

const FormSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M5.33337 14H13.3334C13.687 14 14.0261 13.8595 14.2762 13.6095C14.5262 13.3594 14.6667 13.0203 14.6667 12.6667V11.3333H6.66671V12.6667C6.66671 13.0203 6.52623 13.3594 6.27618 13.6095C6.02613 13.8595 5.687 14 5.33337 14ZM5.33337 14C4.97975 14 4.64061 13.8595 4.39056 13.6095C4.14052 13.3594 4.00004 13.0203 4.00004 12.6667V3.33333C4.00004 2.97971 3.85956 2.64057 3.60952 2.39052C3.35947 2.14048 3.02033 2 2.66671 2C2.31309 2 1.97395 2.14048 1.7239 2.39052C1.47385 2.64057 1.33337 2.97971 1.33337 3.33333V5.33333H4.00004"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6666 11.3333V3.33333C12.6666 2.97971 12.5261 2.64057 12.2761 2.39052C12.0261 2.14048 11.6869 2 11.3333 2H2.66663"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99996 5.33325H6.66663"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.99996 8H6.66663" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default FormSVG;
